import { createFileRoute } from "@tanstack/react-router";

import AddUserForm from "@/components/UserForm/Add/component";
import { checkAuthorizationByRoles } from "@/helpers/authorization";

function AddUser() {
  return (
    <div>
      <AddUserForm />
    </div>
  );
}

export const Route = createFileRoute("/backoffice-users/add/")({
  beforeLoad: async ({ context }) => {
    checkAuthorizationByRoles(context.roles);
  },
  component: AddUser,
});
